// Configuration file with permission categories and the allowable permissions per permission catrgory

const PermissionCategoriesPermissionMapping = [
  {
    permissionCategoryId: "Dashboard",
    permissionCategoryName: "Dashboard",
    permissions: [{ id: "View", name: "View" }],
  },

  {
    permissionCategoryId: "MembershipApplication",
    permissionCategoryName: "Membership Application",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Create", name: "Update" },
    ],
  },

  {
    permissionCategoryId: "MembershipRequests",
    permissionCategoryName: "Membership Requests",
    permissions: [
      { id: "View", name: "View" },
      // { id: "Create", name: "Approve" },
      // { id: "Create", name: "Query" },
      // { id: "Create", name: "Reject" },
    ],
  },

  {
    permissionCategoryId: "MembershipApproval",
    permissionCategoryName: "Membership Approvals",
    permissions: [
      { id: "View", name: "View" },
      // { id: "Create", name: "Verify" },
      // { id: "Create", name: "Approve" },
      // { id: "Create", name: "Query" },
      // { id: "Create", name: "Reject" },
    ],
  },

  {
    permissionCategoryId: "MembershipDirectory",
    permissionCategoryName: "Membership Directory",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
      { id: "Print", name: "Print" },
    ],
  },

  {
    permissionCategoryId: "AccessRequests",
    permissionCategoryName: "Access Requests",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Approve" },
      { id: "Update", name: "Reject" },
    ],
  },

  {
    permissionCategoryId: "ManageRole",
    permissionCategoryName: "Manage Role",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
    ],
  },
  {
    permissionCategoryId: "ManageUser",
    permissionCategoryName: "Manage User",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
    ],
  },

  {
    permissionCategoryId: "MasterList",
    permissionCategoryName: "Master List",
    permissions: [
      { id: "View", name: "View" },
      { id: "Update", name: "Update" },
    ],
  },

  {
    permissionCategoryId: "WorkflowManagement",
    permissionCategoryName: "Workflow Management",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
    ],
  },

  {
    permissionCategoryId: "MembershipTierManagement",
    permissionCategoryName: "Membership Tier",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
    ],
  },

  {
    permissionCategoryId: "AllPayments",
    permissionCategoryName: "All Payments",
    permissions: [
      { id: "View", name: "View" },
    ],
  },

  {
    permissionCategoryId: "MyPayments",
    permissionCategoryName: "My Payments",
    permissions: [
      { id: "View", name: "View" },
      { id: "Pay", name: "Pay" },
      { id: "Export", name: "Export" },
    ],
  },

  {
    permissionCategoryId: "Payments",
    permissionCategoryName: "Payments",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
      { id: "Pay", name: "Pay" },
    ],
  },

  {
    permissionCategoryId: "Membership",
    permissionCategoryName: "Membership",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
      { id: "Renew", name: "Renew" },
      { id: "Print", name: "Print" },
    ],
  },

  {
    permissionCategoryId: "AllRequests",
    permissionCategoryName: "All Requests",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
      { id: "Print", name: "Print" },
    ],
  },

  {
    permissionCategoryId: "MyRequests",
    permissionCategoryName: "My Requests",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
      { id: "Print", name: "Print" },
    ],
  },

  {
    permissionCategoryId: "PendingRequests",
    permissionCategoryName: "Pending Requests",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
      { id: "Print", name: "Print" },
    ],
  },

  {
    permissionCategoryId: "Pending",
    permissionCategoryName: "Pending",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
      { id: "Print", name: "Print" },
    ],
  },

  {
    permissionCategoryId: "ApplicationForm",
    permissionCategoryName: "Application Form",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
      { id: "Print", name: "Print" },
    ],
  },

  {
    permissionCategoryId: "Reports",
    permissionCategoryName: "Reports",
    permissions: [
      { id: "View", name: "View" },
      { id: "Create", name: "Create" },
      { id: "Update", name: "Update" },
      { id: "Delete", name: "Delete" },
      { id: "Print", name: "Print" },
      { id: "Generate", name: "Generate" },
    ],
  },

  // Additional categories can be added here...
];

export default PermissionCategoriesPermissionMapping;
